// extracted by mini-css-extract-plugin
export default {"wrapper":"LocationTreeSelect_wrapper__Fs3hp"};